var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":"","overflow-hidden":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-divider'),_vm._v(_vm._s(_vm.text)),_vm._t("default"),_c('v-divider')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }